import {call, put, select, takeLatest} from 'redux-saga/effects'
import * as authActions from '#app/redux/actions/auth'
import * as interfaceActions from '#app/redux/actions/interface'
import {handleNotify} from "#app/redux/sagas/jobs";
import {Api} from "laravel-request";
import {IndexedDBCache, Tracker, Url} from "finhelper"
import FileHelper from "#app/helpers/FileHelper";
import CacheHelper from "#app/helpers/Cache/CacheHelper";

function* login(action) {
    try {
        const {form, success, error, obj} = action.payload;

        const promise = new Promise((resolve, reject) => {
            Api.makeRequest(
                {
                    method: "POST",
                    url: process.env.REACT_APP_API_WHITESWAN_URL + '/api/v1/call/auth/login',
                    data: {data: form},
                    success: (response, status, xhr) => {
                        success(response, status, xhr);
                        resolve(response);
                    },
                    error: (response) => {
                        console.error(response);
                        error(response);
                        reject();
                    }
                }
            );
        });

        let response = yield promise;

        yield put(authActions.handleGetUser(response));
        yield put(authActions.handleAuth());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* register(action) {
    try {
        const {form, success, error, obj, callback} = action.payload;

        const promise = new Promise((resolve, reject) => {
            Api.post('auth', 'register', form)
                .withValidateForm(obj)
                .withoutNotify()
                .call((response, status, xhr) => {
                    Tracker.reachGoal('register_finished', {
                        //user_id: this.props.client ? this.props.client.id : null
                    });
                    success(response, status, xhr);
                    resolve(response);
                }, (errors) => {
                    console.error(errors);
                    error(errors);
                });
        });

        let response = yield promise;
        yield put(authActions.handleGetUser(response));

        yield put(authActions.handleAuth())

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }

    } catch (err) {
        console.error(err);
    }
}

function* requestRegister(action) {
    try {
        const {form, success, error, obj} = action.payload;

        const promise = new Promise((resolve, reject) => {
            Api.post('auth', 'request-register', form)
                .withValidateForm(obj)
                .withoutNotify()
                .call((response, status, xhr) => {
                    Tracker.reachGoal('request_register_code', {
                        // //user_id: this.props.client ? this.props.client.id : null
                    });
                    success(response, status, xhr);
                    resolve(response);
                }, (errors) => {
                    console.error(errors);
                    error(errors);
                });
        });
    } catch (err) {
        console.error(err);
    }
}

function* forgot(action) {
    try {
        const {form, success, error, obj} = action.payload;

        const promise = new Promise((resolve, reject) => {
            Api.post('auth', 'forgot', form)
                .withValidateForm(obj)
                .withoutNotify()
                .call((response, status, xhr) => {
                    success(response, status, xhr);
                    resolve(response);
                }, (errors) => {
                    console.error(errors);
                    error(errors);
                });
        });

        let response = yield promise;

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }

    } catch (err) {
        console.error(err);
    }
}

function* requestForgot(action) {
    try {
        const {form, success, error, obj} = action.payload;

        const promise = new Promise((resolve, reject) => {
            Api.post('auth', 'request-forgot', form)
                .withValidateForm(obj)
                .withoutNotify()
                .call((response, status, xhr) => {
                    success(response, status, xhr);
                    resolve(response);
                }, (errors) => {
                    console.error(errors);
                    error(errors);
                });
        });
    } catch (err) {
        console.error(err);
    }
}

function* logout(action) {
    try {
        const {success, error, obj} = action.payload;

        yield put(authActions.handleLogout());
        yield put(interfaceActions.handleLogoutInterface());
        yield call(history.push, '/');

        const promise = new Promise((resolve, reject) => {
            Api.get('auth', 'logout').call((response) => {
                if (response.result === 'success') {
                    success();
                    resolve(response);
                }
            }, (errors) => {
                console.error(errors);
                error(errors);
            });
        });

        let response = yield promise;
        yield handleNotify({data: {jobs: []}});

    } catch (err) {
        console.error(err);
    }
}

function* getServer(action)
{
    try {
        IndexedDBCache.get(CacheHelper.SERVER_DATA).then((data) =>
        {
            if(!data)
            {
                Api.makeRequest(
                    {
                        method: "GET",
                        url: process.env.REACT_APP_API_URL + '/api/v1/call/system/index',
                        success: ({data}, status, xhr) => {
                            FileHelper.data = data;
                            IndexedDBCache.set(CacheHelper.SERVER_DATA, data)
                        },
                        error: (response) => {

                        }
                    }
                )
            }else{
                FileHelper.data = data;
            }
        });
    } catch (err) {
        console.warn(err);
    }
}

function* getUser(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.makeRequest(
                {
                    method: "GET",
                    url: process.env.REACT_APP_API_URL + '/api/v1/call/profile/index',
                    success: (response, status, xhr) => {
                        resolve(response);
                    },
                    error: (response) => {
                        reject();
                    }
                }
            )
        });

        //если по токену входит, то нужно удалить его из памяти
        localStorage.removeItem('token')

        let response = yield promise;

        if(response.data?.api_token)
        {
            localStorage.setItem('api_token', response.data?.api_token);
        }

        yield put(authActions.handleGetUser(response));

        if (typeof action.payload === 'undefined' || action.payload.load !== false) {
            yield put(authActions.handleAuth());
        }

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        let url = Url.getCurrentUrl();

        if (url.indexOf('/cabinet') !== -1) {
            //history.push('/login');
        }

        if(action.payload && typeof action.payload.fallback === "function")
        {
            yield call(action.payload.fallback);
        }

        console.warn(err);
    }
}

function* socketsConnecting(action) {
    //call middleware
}

function* postUser(action) {
    try {
        const {form, success, error, obj} = action.payload;

        const promise = new Promise((resolve, reject) => {
            Api.post('profile', 'profile', form).withValidateForm(obj).call((response, status, xhr) => {
                success(response, status, xhr);
                resolve(response);
            }, (errors) => {
                console.error(errors);
                error(errors);
            });
        });

        let response = yield promise;

        yield put(authActions.handleGetUser(response));

        yield put(authActions.handleAuth());
    } catch (err) {
        console.error(err);
    }
}

function* handleAuth(action) {
    try {
        const state = yield select();
        if (state.auth && state.auth.data) {
            yield put(authActions.socketsConnecting({
                userId: state.auth.data.id,
                role: 'crm'
            }));
        }
    } catch (err) {
        console.error(err);
    }
}

export default function* watcher() {
    // yield takeEvery('*', function* logger(action) {
    //     const state = yield select()
    //
    //     // console.log('action', action)
    //     // console.log('state after', state)
    // })
    yield takeLatest(authActions.login, login)
    yield takeLatest(authActions.register, register)
    yield takeLatest(authActions.requestRegister, requestRegister)
    yield takeLatest(authActions.forgot, forgot)
    yield takeLatest(authActions.requestForgot, requestForgot)
    yield takeLatest(authActions.logout, logout)
    yield takeLatest(authActions.getUser, getUser)
    yield takeLatest(authActions.postUser, postUser)
    yield takeLatest(authActions.handleAuth, handleAuth)
    yield takeLatest(authActions.socketsConnecting, socketsConnecting)
}
